module.exports = __webpack_public_path__ + "img/one.a64a39d6.png";